import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { BalikovnaPickup } from 'shared-ui/providers/balikovna-pickup';

@Component({
  selector: 'balikovna-pickup',
  standalone: true,
  imports: [MatButtonModule],
  template: `<div></div>
    <div style="position: absolute;top: 0.5rem; right: 0.5rem;">
      <button mat-mini-fab color="secondary" (click)="this.dialogRef.close(null)">
        <i class="material-icons">close</i>
      </button>
    </div>
    <iframe
      src="https://b2c.cpost.cz/locations/?type=BALIKOVNY"
      allow="geolocation"
      height="100%"
      width="100%"></iframe>`,
})
export class BalikovnaPickupComponent {
  dialogRef = inject(MatDialogRef);
  private pickupService = inject(BalikovnaPickup);

  constructor() {
    this.pickupService.point.pipe(takeUntilDestroyed()).subscribe(point => {
      this.dialogRef.close(point);
    });
  }
}
